(function () {
    'use strict';
    $(document).ready(function () {

        var hash = window.location.href.split("#")[1];
        if(hash && $("#" + hash).hasClass('collapse')){
            $("#" + hash).collapse('show');
            var positionTop = $("#" + hash).offset().top - 100;
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        }


        $('.news .news-excerpt').click(function (e) {
            e.preventDefault();
            $(this).addClass('active');
            $(this).siblings().removeClass('active');

            var isPress = $(this).hasClass('press');

            var newsPrevExcerpts = $(this).prevAll();
            var newsPrevExcerptsHeight = 0;
            newsPrevExcerpts.each(function () {
                newsPrevExcerptsHeight = newsPrevExcerptsHeight + $(this).height();
            });
            newsPrevExcerptsHeight = newsPrevExcerptsHeight + newsPrevExcerpts.length * 35;

            var post_id = $(this).data("news-id");

            if (window.matchMedia("(min-width: 992px)").matches) {
                $('.news .news-full-single').animate({
                    paddingTop: newsPrevExcerptsHeight
                }, 500);

                $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    method: "post",
                    timeout: 10000,
                    data: {
                        action: isPress ? "get_press" : "get_news",
                        post_id: post_id
                    },
                    success: function (data) {
                        $('.news-full-single #news-from-ajax').html(data).slideDown();
                    },
                    error: function () {
                        $('.news-full-single .ajax-info-news .loading-error').slideDown();
                    },
                    beforeSend: function () {
                        $('.news-full-single #news-from-ajax').slideUp();
                        $('.news-full-single .ajax-info-news .loading-error').slideUp();
                        $('.news-full-single .ajax-info-news .loader').slideDown();
                    },
                    complete: function () {
                        $('.news-full-single .ajax-info-news .loader').slideUp();
                    },
                });
            } else {
                $(this).find('.news-full').slideDown();
                var that = $(this);

                $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    method: "post",
                    timeout: 10000,
                    data: {
                        action: isPress ? "get_press" : "get_news",
                        post_id: post_id
                    },
                    success: function (data) {
                        that.find('#news-from-ajax').html(data).slideDown();
                    },
                    error: function () {
                        that.find('.ajax-info-news .loading-error').slideDown();
                    },
                    beforeSend: function () {
                        that.find('.ajax-info-news .loading-error').slideUp();
                        that.find('.ajax-info-news .loader').slideDown();
                    },
                    complete: function () {
                        that.find('.ajax-info-news .loader').slideUp();
                    },
                });
            }
        });

        $('.sidemenu .sidemenu-menu a').click(function () {
            $(this).addClass('active');
            $(this).parent().siblings().children().removeClass('active');
        });

        ScrollTrigger.matchMedia({
            "(min-width: 992px)": function () {
                ScrollTrigger.create({
                    trigger: ".subpage .sidemenu-trigger",
                    pin: ".subpage .sidemenu-menu",
                    start: "top 80px"
                });
            }
        });

        $('#search-cats-trigger').on('click', function () {
            $(this).toggleClass('open');
            $('.cats-list').fadeToggle();
        });

        function formatContacts(data) {
            var htmlOutput = '';
            for (const [key, value] of Object.entries(data)) {
                htmlOutput += '<div class="row no-gutters"><div class="col-12"><h2>' + key + '</h2></div></div>';

                value.forEach(function (contact) {
                    var position = contact.position ? contact.position : '';
                    htmlOutput += '<div class="row no-gutters">';
                    htmlOutput += '<div class="col-3"><p>' + contact.names + '<br><span>' + position + '</span></p></div>';
                    htmlOutput += '<div class="col-2"><p>' + contact.room + '</p></div>';
                    htmlOutput += '<div class="col-2"><p>' + contact.group + '</p></div>';
                    htmlOutput += '<div class="col-2"><p>' + contact.phone_number + '</p></div>';
                    htmlOutput += '<div class="col-3"><p><a href="mailto:' + contact.email + '">' + contact.email + '</a></p></div>';
                    htmlOutput += '</div>';
                });

            }
            return htmlOutput;
        }

        $('.contacts-form').on('submit', function (e) {
            e.preventDefault();

            $('#search-cats-trigger').removeClass('open');
            $('.cats-list').fadeOut();

            var searchName = $('#name').val();
            var searchCats = [];
            $('.cats-list input:checked').each(function () {
                searchCats.push($(this).attr('value'));
            });

            const regex = new RegExp("([0-9]+)|(\\*)");
            if(regex.test(searchName)){
                $('#contacts-from-ajax').html("");
                $('.ajax-info-contacts .loading-error').slideDown();
            }else {
                $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    method: "post",
                    timeout: 10000,
                    data: {
                        action: "get_contacts",
                        names: searchName,
                        categories: searchCats
                    },
                    success: function (data) {
                        $('#contacts-from-ajax').html(formatContacts(data)).slideDown();
                    },
                    error: function () {
                        $('.ajax-info-contacts .loading-error').slideDown();
                    },
                    beforeSend: function () {
                        $('#contacts-from-ajax').slideUp();
                        $('.ajax-info-contacts .loading-error').slideUp();
                        $('.ajax-info-contacts .loader').slideDown();
                    },
                    complete: function () {
                        $('.ajax-info-contacts .loader').slideUp();
                    }
                });
            }
        });

        $('.subpage .contacts .cats-list').mCustomScrollbar({
            mouseWheel: {
                enable: true
            }
        });

        $('.subpage .contacts .contacts-results').mCustomScrollbar({
            axis: "x",
            mouseWheel: {
                enable: true
            }
        });

        // SOCIAL SHARING
        const $share = $('#share');
        $share.css('opacity', 1);
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$share.attr('data-templateURL')}/dist/images/facebook.svg`,
                    inlineSvg: true,
                },
                {
                    share: "twitter",
                    logo: `${$share.attr('data-templateURL')}/dist/images/twitter.svg`,
                    inlineSvg: true,
                    via: "pgnig",
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                }
            ]
        });


        //tools show/hide
        $('#tools-toggle').click(function () {
            $('.tools-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse, .subpage .accordion .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top - 100;
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            window.location.href = "#" + $(this).attr('id');
            $(window).resize();
        });

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.offset.left - 20;
                return position;
            },
        });

        function updateTableSize() {
            $('.table-container').each(function () {
                if ($(this).parent().hasClass('panel-body')) return;
                var containerWidth = $(this).width();
                var tableWidth = $('table', this).width();

                if (tableWidth > containerWidth) {
                    $(this).addClass('scrollable');
                    $(this).mCustomScrollbar({
                        axis: "x",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $(this).removeClass('scrollable');
                    $(this).mCustomScrollbar('destroy');
                }
            });
        }

    });
}(jQuery));
